import { GET_ASSIGNVEHICLE_REQUESTED, GET_LISTASSIGNEDVEHICLE_REQUESTED, GET_REQUESTVEHICLE_REQUESTED, GET_UPDATEASSIGNDRIVER, GET_UPDATEASSIGNDRIVER_REQUESTED, GET_UPDATEASSIGNSUBVENDOR_REQUESTED, GET_UPDATEASSIGNVEHICLE_REQUESTED } from "resources/actionTypes";

export function getRequestVehicle(data) {
  return {
    type: GET_REQUESTVEHICLE_REQUESTED,
    payload: data,
  };
}
export function getListAssignedVehicle(data) {
  return {
    type: GET_LISTASSIGNEDVEHICLE_REQUESTED,
    payload: data,
  };
}
export function getAssignVehicle(data) {
  return {
    type: GET_ASSIGNVEHICLE_REQUESTED,
    payload: data,
  };
}
export function updateAssignVehicle(val) {
  const data = {
    userUpdateAssignVehicle:val
  }
  return {
    type: GET_UPDATEASSIGNVEHICLE_REQUESTED,
    payload: data,
  };
}
export function updateAssignDriver(val) {
  const data ={
    userUpdateAssignDriver: val
  }
  return {
    type: GET_UPDATEASSIGNDRIVER_REQUESTED,
    payload: data,
  }
}
export function updateAssignSubVendor(val) {
  const data ={
    userUpdateAssignSubVendor: val,
  }
  return {
    type: GET_UPDATEASSIGNSUBVENDOR_REQUESTED,
    payload: data,
  }
}